export default "__VITE_ASSET__CtiglN4I__"